import IconWeb from "tabler-icons/world.tsx";
import IconDatabase from "tabler-icons/database.tsx";
import IconDocument from "tabler-icons/file.tsx";
import IconBulb from "tabler-icons/bulb.tsx";
import IconError from "tabler-icons/x.tsx";
import IconCircle from "tabler-icons/circle.tsx";
import type { Thinking, ThinkingItem } from "db";
import { useSignal } from "@preact/signals";
import { useAppData } from "./App.tsx";

export function Thinking({ thinking }: { thinking: Thinking | null }) {
  if (!thinking || !thinking.items?.length) return;

  const appData = useAppData();
  const isLastMessage = appData.messages.value.at(-1)?.thinking == thinking;
  const hideToggle = isLastMessage && appData.generating.value && thinking.open == true;


  const openState = useSignal<boolean | null>(null);
  // If we haven't opened or closed, get open state from message, otherwise signal
  const open = openState.value !== null ? openState.value : thinking.open;

  const getIcon = (item: ThinkingItem) => {
    let Icon = IconCircle;
    switch (item.type) {
      case "thinking": Icon = IconBulb; break;
      case "research": Icon = IconWeb; break;
      case "document": Icon = IconDocument; break;
      case "sql": Icon = IconDatabase; break;
      case "error": Icon = IconError; break;
    }

    return <Icon />;
  }

  return <div class="thinking-container">
    {!hideToggle &&
      <button class="toggle-thinking" type="button" onClick={() => openState.value = !open}><IconBulb height={18} width={18} />{open ? "Hide Thinking ▾" : "Show Thinking ▸"}</button>
    }
    {open && <div class="thinking">
      <ul>
        {thinking.items.map((item, i) =>
          <li key={i}
            data-done={item.status == 2}
          >
            {item.status == 1 && <div class="loader"></div>}
            {getIcon(item)}
            <span dangerouslySetInnerHTML={{ __html: item.title }}></span>
          </li>
        )}
      </ul>
    </div>}
  </div>
}